export default __webpack_public_path__ + "static/media/PSYCHIATRY.1c93934d.png";